export const DefaultScanRecvRatio = 1;

export enum PoRecvActionType {
  SetCrossWarehouseReceive,
  SetCurrentPo,
  SetEnableLot,
  SetEnablePOReceiveControl,
  SetEnablePOReceiveExtra,
  SetEnableUom,
  SetLockScreen,
  SetPoLines,
  SetPoList,
  SetPoOverRecvPercent,
  SetRecvItems,
  SetRecvStep,
  SetScanRecvCountType,
  SetScanRecvLotPolicy,
  SetScanRecvLotUniNum,
  SetScanRecvRatio,
  SetScanRecvRatioType,
  SetScanRecvScopeType,
  SetSelectedWarehouse,
  SetTimeZone,
};

export enum PoRecvStep {
  PoInfo = 'poInfo',
  RecvPo = 'recvPo',
  ScanPo = 'scanPo',
};

export enum ScanRecvCountType {
  Default,
  Custom,
};

export enum ScanRecvLotPolicy {
  InputManually,
  AssignSameLot,
};

export enum ScanRecvRatioType {
  FixedRatio,
  Unreceived,
};

export enum ScanRecvScopeType {
  CurrentPo,
  AllPo,
};

type PoRecvAction = {
  type: PoRecvActionType,
  params: any,
};

type PoRecvState = {
  crossWarehouseReceive: string;
  currentPo: StringKAnyVPair;
  enableLot: boolean;
  enablePOReceiveControl: boolean;
  enablePOReceiveExtra: string;
  enableUom: boolean;
  lockScreen: boolean;
  poLines: StringKAnyVPair[];
  poList: StringKAnyVPair[];
  poOverRecvPercent: number;
  recvItems: StringKAnyVPair[];
  recvStep: PoRecvStep;
  scanRecvCountType: ScanRecvCountType;
  scanRecvLotPolicy: ScanRecvLotPolicy;
  scanRecvLotUniNum: string;
  scanRecvRatio: number;
  scanRecvRatioType: ScanRecvRatioType;
  scanRecvScopeType: ScanRecvScopeType;
  selectedWarehouse: StringKAnyVPair;
  timeZone: string;
};

export const initialState = (state: StringKAnyVPair) => ({
  crossWarehouseReceive: '0',
  currentPo: {},
  enableLot: false,
  enablePOReceiveControl: false,
  enablePOReceiveExtra: '0',
  enableUom: false,
  lockScreen: false,
  poLines: [],
  poList: [],
  poOverRecvPercent: 0,
  recvItems: [],
  recvStep: PoRecvStep.ScanPo,
  scanRecvCountType: ScanRecvCountType.Default,
  scanRecvLotPolicy: ScanRecvLotPolicy.InputManually,
  scanRecvLotUniNum: '',
  scanRecvRatio: DefaultScanRecvRatio,
  scanRecvRatioType: ScanRecvRatioType.FixedRatio,
  scanRecvScopeType: ScanRecvScopeType.AllPo,
  selectedWarehouse: {},
  timeZone: '',
  ...state,
});

export const isValidStep = (val: any) => Object.values(PoRecvStep).includes(val as PoRecvStep);

export const reducer = (state: PoRecvState, action: PoRecvAction) => {
  switch (action.type) {
    case PoRecvActionType.SetCrossWarehouseReceive:
      return { ...state, crossWarehouseReceive: action.params };

    case PoRecvActionType.SetCurrentPo:
      return { ...state, currentPo: { ...action.params } };

    case PoRecvActionType.SetEnableLot:
      return { ...state, enableLot: action.params };

    case PoRecvActionType.SetEnablePOReceiveControl:
      return { ...state, enablePOReceiveControl: action.params };

    case PoRecvActionType.SetEnablePOReceiveExtra:
      return { ...state, enablePOReceiveExtra: action.params };

    case PoRecvActionType.SetEnableUom:
      return { ...state, enableUom: action.params };

    case PoRecvActionType.SetLockScreen:
      return { ...state, lockScreen: action.params };

    case PoRecvActionType.SetPoLines:
      return { ...state, poLines: [ ...action.params ] };

    case PoRecvActionType.SetPoList:
      return { ...state, poList: [ ...action.params ] };

    case PoRecvActionType.SetPoOverRecvPercent:
      return { ...state, poOverRecvPercent: action.params };

    case PoRecvActionType.SetRecvItems:
      return { ...state, recvItems: action.params };

    case PoRecvActionType.SetRecvStep:
      return { ...state, recvStep: action.params };

    case PoRecvActionType.SetScanRecvCountType:
      return { ...state, scanRecvCountType: action.params };

    case PoRecvActionType.SetScanRecvLotPolicy:
      return { ...state, scanRecvLotPolicy: action.params };

    case PoRecvActionType.SetScanRecvLotUniNum:
      return { ...state, scanRecvLotUniNum: action.params };

    case PoRecvActionType.SetScanRecvRatio:
      return { ...state, scanRecvRatio: action.params };

    case PoRecvActionType.SetScanRecvRatioType:
      return { ...state, scanRecvRatioType: action.params };

    case PoRecvActionType.SetScanRecvScopeType:
      return { ...state, scanRecvScopeType: action.params };

    case PoRecvActionType.SetSelectedWarehouse:
      return { ...state, selectedWarehouse: action.params };

    case PoRecvActionType.SetTimeZone:
      return { ...state, timeZone: action.params };

    default:
      return state;
  }
};
